import { observer } from 'mobx-react-lite';
import { useLocaleMessage } from '@/react/hooks/useLocaleMessage';
import { DidYouMean } from './internal/DidYouMean';
import { KeepSearchingFor } from './internal/KeepSearchingFor';
import type { ISearchSuggestionsProps } from './ISearchSuggestionsProps';
import { SuggestedSearchTerms } from '../SuggestedSearchTerms';
import { search_box_frame_suggestedTerms } from "@/lang/__generated__/ahnu/search_box_frame_suggestedTerms";

/**
 * A simple wrapper to select the correct search suggestions based on the search term.
 */
export const SearchSuggestions = observer(function SearchSuggestions(
  props: ISearchSuggestionsProps
) {
  const { vm } = props;
  const [msg] = useLocaleMessage();

  if (vm.didYouMean.length > 0) {
    // If there are suggestions based on a search term, we show them
    return <DidYouMean {...props} />;
  }

  // If not, we fallback to the suggested search terms
  //
  // This will likely happen on initialization or if the API returns no suggestions
  //
  // In this moment we also show to the user the "Keep Searching For" component
  // if there is search history available.
  return (
    <>
      <KeepSearchingFor {...props} />
      <SuggestedSearchTerms
        title={msg(search_box_frame_suggestedTerms)}
        {...props}
      />
    </>
  );
});
